// Module
var code = "<div id=toggle-published><label class=switch><input type=checkbox ng-model=$ctrl.toggleOn ng-checked=$ctrl.toggleOn ng-change=$ctrl.onStatusChange($event) ng-disabled=\"$ctrl.status === 'Incomplete'\"><div class=slider></div></label></div>";
// Exports
module.exports = code;